// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login--container {
  height: 100vh;
  display: flex;
  background: rgb(157, 157, 156);
  background: linear-gradient(180deg,
      rgba(157, 157, 156, 1) 59%,
      rgba(255, 204, 51, 1) 96%);
}

.form--container {
  display: flex;
  flex-basis: 60%;
  justify-content: center;
  align-items: center;
}

.logo--container {
  flex-basis: 40%;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 6rem;
  padding: 2rem;
}

.logo--state {
  max-width: 100px;
  height: auto;
}

.dynamic--logo {
  display: flex;
  width: 100%;
  min-height: 100px;
}

.static--logo {
  justify-content: end;
  display: flex;
  width: 100%;
}

.form--item {
  display: flex;
  height: fit-content;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 2rem;
  width: 100%;
}

.input--style {
  display: flex;
  width: 100%;
  max-width: 370px;
  background-color: #e8f0fe;
  border: 1px solid #ebf1ff;
  border-bottom: none;
  border-radius: 0.5rem 0.5rem 0.3rem 0.3rem;
}

.logo--img {
  max-width: 70%;
  height: auto;
}

.form--button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.input--form {
  display: flex;
  width: 100%;
}

.hidde--message {
  display: hidden;
}

.show--message {
  display: flex;
  justify-content: center;
  font-weight: bold;
  color: white;
  background-color: #d32f2f;
  border: 1px solid #d32f2f;
  border-radius: 2rem;
  width: 70%;
  margin: 0 auto;
}

.icon-alignment {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e8f0fe;
  border: 1px solid transparent;
}

#filled-adornment-password,
#filled-adornment-user {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 10px;
  height: auto;
  gap: 4px;
}

.forget-password {
  cursor: pointer;
  color: #ffffff;
  font-weight: bold;
}

.switch-input {
  display: flex;
  max-width: 300px;
  justify-content: space-evenly;
  align-items: center;
  background-color: #ffe495;
  padding: 0px 35px;
  border-radius: 30px;
}

@media only screen and (max-width: 750px) {
  .login--container {
    height: 100vh;
    flex-direction: column;
    justify-content: start;
    align-items: center;
  }

  .logo--container {
    justify-content: end;
    align-items: center;
    gap: 2rem;
    padding: 1rem;
  }

  .input--style {
    width: 100%;
    max-width: 480px;
  }
}

@media only screen and (max-width: 426px) {
  .login--container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    padding-top: 4rem;
  }

  .logo--container {
    flex-basis: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: center;
    gap: 2rem;
    padding: 1rem;
  }

  .dynamic--logo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 100px;
  }

  .logo--state {
    max-width: 230px;
    height: auto;
  }

  .static--logo {
    justify-content: center;
    align-items: center;
  }

  .logo--img {
    max-width: 250px;
    height: auto;
  }

  .form--container {
    display: flex;
    flex-basis: auto;
    align-items: start;
    height: auto;
  }

  .form--item {
    justify-content: flex-start;
    align-items: center;
    gap: 1.5rem;
    padding: 0.5rem;
    width: 100%;
    max-width: 300px;
    height: 100%;
  }

  .input--style {
    width: 100%;
    max-width: 280px;
  }

  .switch-input {
    max-width: 150px;
    padding: 0px 35px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Login/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B;;gCAE8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".login--container {\n  height: 100vh;\n  display: flex;\n  background: rgb(157, 157, 156);\n  background: linear-gradient(180deg,\n      rgba(157, 157, 156, 1) 59%,\n      rgba(255, 204, 51, 1) 96%);\n}\n\n.form--container {\n  display: flex;\n  flex-basis: 60%;\n  justify-content: center;\n  align-items: center;\n}\n\n.logo--container {\n  flex-basis: 40%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 6rem;\n  padding: 2rem;\n}\n\n.logo--state {\n  max-width: 100px;\n  height: auto;\n}\n\n.dynamic--logo {\n  display: flex;\n  width: 100%;\n  min-height: 100px;\n}\n\n.static--logo {\n  justify-content: end;\n  display: flex;\n  width: 100%;\n}\n\n.form--item {\n  display: flex;\n  height: fit-content;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2rem;\n  padding: 2rem;\n  width: 100%;\n}\n\n.input--style {\n  display: flex;\n  width: 100%;\n  max-width: 370px;\n  background-color: #e8f0fe;\n  border: 1px solid #ebf1ff;\n  border-bottom: none;\n  border-radius: 0.5rem 0.5rem 0.3rem 0.3rem;\n}\n\n.logo--img {\n  max-width: 70%;\n  height: auto;\n}\n\n.form--button {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.input--form {\n  display: flex;\n  width: 100%;\n}\n\n.hidde--message {\n  display: hidden;\n}\n\n.show--message {\n  display: flex;\n  justify-content: center;\n  font-weight: bold;\n  color: white;\n  background-color: #d32f2f;\n  border: 1px solid #d32f2f;\n  border-radius: 2rem;\n  width: 70%;\n  margin: 0 auto;\n}\n\n.icon-alignment {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #e8f0fe;\n  border: 1px solid transparent;\n}\n\n#filled-adornment-password,\n#filled-adornment-user {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px 10px;\n  height: auto;\n  gap: 4px;\n}\n\n.forget-password {\n  cursor: pointer;\n  color: #ffffff;\n  font-weight: bold;\n}\n\n.switch-input {\n  display: flex;\n  max-width: 300px;\n  justify-content: space-evenly;\n  align-items: center;\n  background-color: #ffe495;\n  padding: 0px 35px;\n  border-radius: 30px;\n}\n\n@media only screen and (max-width: 750px) {\n  .login--container {\n    height: 100vh;\n    flex-direction: column;\n    justify-content: start;\n    align-items: center;\n  }\n\n  .logo--container {\n    justify-content: end;\n    align-items: center;\n    gap: 2rem;\n    padding: 1rem;\n  }\n\n  .input--style {\n    width: 100%;\n    max-width: 480px;\n  }\n}\n\n@media only screen and (max-width: 426px) {\n  .login--container {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    align-items: center;\n    padding-top: 4rem;\n  }\n\n  .logo--container {\n    flex-basis: auto;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: end;\n    align-items: center;\n    gap: 2rem;\n    padding: 1rem;\n  }\n\n  .dynamic--logo {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    min-height: 100px;\n  }\n\n  .logo--state {\n    max-width: 230px;\n    height: auto;\n  }\n\n  .static--logo {\n    justify-content: center;\n    align-items: center;\n  }\n\n  .logo--img {\n    max-width: 250px;\n    height: auto;\n  }\n\n  .form--container {\n    display: flex;\n    flex-basis: auto;\n    align-items: start;\n    height: auto;\n  }\n\n  .form--item {\n    justify-content: flex-start;\n    align-items: center;\n    gap: 1.5rem;\n    padding: 0.5rem;\n    width: 100%;\n    max-width: 300px;\n    height: 100%;\n  }\n\n  .input--style {\n    width: 100%;\n    max-width: 280px;\n  }\n\n  .switch-input {\n    max-width: 150px;\n    padding: 0px 35px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
